'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import frontendService from '../services/FrontendService';
import { resolveRoleHome } from '../lib/roleRouting';
import { getTenantHomepageUrl } from '../lib/tenantContext';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    // Route authenticated users to their own environment; office accounts (no
    // live environment) are bounced back to the tenant site. Guests go to login.
    if (frontendService.isAuthenticated()) {
      const home = resolveRoleHome(frontendService.getUserData());
      if (home) {
        router.push(home);
      } else {
        window.location.href = getTenantHomepageUrl() || '/login';
      }
    } else {
      router.push('/login');
    }
  }, [router]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Live chat
        </h1>
        <p className="text-gray-600 mb-8">
          Routing you to the right workspace for your account.
        </p>
        <div className="text-sm text-gray-500">
          Redirecting…
        </div>
      </div>
    </div>
  );
}
